import { useI18n } from '@/libraries/contexts/i18n-context';
import Typography from '@/components/atoms/typography/typography';
import styles from './room-matrix-room-beds.module.scss';

interface RoomMatrixRoomBedsProps {
  /** The number of adult beds */
  adultBeds: number;
  /** The number of children beds */
  childrenBeds: number;
  /** The number of extra beds */
  extraBeds: number;
  /** The number of persons */
  personsNo: number;
}

const RoomMatrixRoomBeds = ({
  adultBeds,
  childrenBeds,
  extraBeds,
  personsNo,
}: RoomMatrixRoomBedsProps) => {
  const { t } = useI18n();
  const totalBeds = adultBeds + childrenBeds + extraBeds;

  return (
    <div className={styles.component}>
      <Typography className={styles.heading} tagStyle="bodySmallBold">
        {`${t('items.modules.roomMatrix.personsNo', { personsNo })}`}
      </Typography>

      {totalBeds > 0 && (
        <Typography className={styles.content} tagStyle="bodySmall">
          {' / '}

          {[
            adultBeds && t('items.modules.roomMatrix.adultBeds', { adultBeds }),
            childrenBeds &&
              t('items.modules.roomMatrix.childrenBeds', { childrenBeds }),
            extraBeds && t('items.modules.roomMatrix.extraBeds', { extraBeds }),
          ]
            .filter(Boolean)
            .join(' • ')}
        </Typography>
      )}
    </div>
  );
};

RoomMatrixRoomBeds.displayName = 'RoomMatrixRoomBeds';

export default RoomMatrixRoomBeds;
